import React from "react";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return (
    <footer className="border-t border-white/10 bg-[#07090D] text-white">
      <div className="mx-auto flex w-full max-w-[1600px] flex-col items-center justify-between gap-3 px-4 py-6 text-center sm:px-6 md:flex-row md:text-left lg:px-8">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#67A3FA]">NinetySix Technologies LLC</p>
          <p className="mt-1 text-xs text-white/35">© 2026 NinetySix. All rights reserved.</p>
        </div>
        {!isLoginPage && (
          <div className="flex items-center gap-5 text-xs text-white/45">
            <Link to="/content?pageName=termsCondition" className="transition hover:text-white">Terms & Conditions</Link>
            <Link to="/content?pageName=privacyPolicy" className="transition hover:text-white">Privacy Policy</Link>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
